export enum EndpointType {
  BACKEND = 'backend'
}
